/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import "./Competences.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FaCheck, FaPen, FaTrash } from "react-icons/fa";
import BtnEcouteMarche from "Components/Boutons/BtnEcouteMarche/BtnEcouteMarche";
import { InputText } from "primereact/inputtext";
import BtnBlancLeft from "Components/Boutons/BtnBlancLeft/btn-blanc-left";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import BtnBleuLeft from "Components/Boutons/BtnBleuLeft/btn-bleu-left";
import { Toast } from "primereact/toast";
import {
  updateAuth,
  updateCompletionLevel,
  updateSkills,
} from "Redux/Actions/authActions";
import BtnRetour from "Components/Boutons/BtnRetour/btn-retour";
import { fetchGet, fetchPut } from "Services/apiESA";
import { errorToast, successToast } from "Services/toastFunctions";

const Competences = (props) => {
  const [currentUser, setCurrentUser] = useState(props.auth.userConnected);
  const successUpdate = useRef(null);
  const [countForm, setCountForm] = useState(1);
  const [validated, setValidated] = useState(false);
  const [competences, setCompetences] = useState([]);

  const [deletedIds, setDeletedIds] = useState([]);

  const [modified, setModified] = useState(false);

  const convertObjectNumericKeys = (data) => {
    // If skills is an object, convert it to an array
    if (typeof data === "object") return Object.values(data);
    return data;
  };

  useEffect(() => {
    if (currentUser.resume !== null && currentUser.resume?.skills)
      setCompetences(convertObjectNumericKeys(currentUser.resume.skills));
  }, []);

  const verifyDataInstance = (i) => {
    if (competences[i].skill != "") return true;
    return false;
  };

  const verifyData = () => {
    setValidated(true);
    var verifiedData = true;
    for (let index = 0; index < competences.length; index++) {
      let check = verifyDataInstance(index);
      verifiedData = verifiedData ? check : false;
    }
    return verifiedData;
  };

  const addCompetence = () => {
    if (competences.length == 8) {
      errorToast("Vous pouvez ajouter au maximum 8 compétences");
      return;
    }
    setValidated(true);
    var verified = verifyData();
    if (verified == true) {
      const newCompetence = {
        skill: "",
        numCompetence: countForm,
      };
      setCountForm(countForm + 1);
      setCompetences([...competences, newCompetence]);
      setValidated(false);
    }
  };

  const majCompetence = (e, i) => {
    const newArray = [...competences];
    newArray[i].skill = e.target.value;
    setCompetences(newArray);
    verifyData(i);
  };

  const supprCompetence = (i, skillId) => {
    // Ajoute l'id de l'objet à supprimer dans le tableau des ids à supprimer
    if (skillId) setDeletedIds([...deletedIds, skillId]);
    const newArray = [...competences];
    newArray.splice(i, 1);
    setCompetences(newArray);
  };

  const Valider = () => {
    setValidated(true);
    if (competences.length == 0) {
      errorToast("Au moins une compétence est requise");
      return;
    }
    if (verifyData()) {
      updateSkills();
      setModified(false);
    }
  };

  const updateSkills = async () => {
    //? Remove id de l'objet props.user et modification l'objet du CV
    const skillsArray = {
      skills: [...competences],
    };

    // Ajout des ids à supprimer dans le tableau skills
    if (deletedIds.length > 0)
      skillsArray.skills = [
        ...skillsArray.skills,
        ...deletedIds.map((id) => ({ id, delete: true })),
      ];

    // Vide le tableau des ids à supprimer
    setDeletedIds([]);
    const cVId = props.auth.userConnected.resume.id;
    const userId = props.auth.userConnected.id;

    const updatedUser = await fetchPut(`/cvs/${cVId}`, skillsArray);
    if (updatedUser.error) {
      errorToast(
        updatedUser.error.response?.data?.detail || "Une erreur est survenue"
      );
      return;
    }

    const convertedSkills = convertObjectNumericKeys(updatedUser.data.skills);
    setCompetences(convertedSkills);
    props.handleUpdateSkills(convertedSkills);
    successToast("Votre mise à jour a bien été prise en compte");

    const completionRate = await fetchGet(
      `/users/${userId}/profile_completion_rate`
    );
    if (completionRate.error) {
      errorToast(
        completionRate.error.response?.data?.detail || "Une erreur est survenue"
      );
      return;
    }
    props.handleUpdateCompletionLevel(completionRate.data);
  };

  return (
    <div>
      <Toast ref={successUpdate} />
      {props.auth.isConnected && (
        <div className="article_actu">
          <NavBarTab
            id="desktop"
            select="profiledit"
            activeIndex={props.activeIndex}
            items={props.items}
          />
          <BtnEcouteMarche items={props.items} />

          <div className="titre_de_page">
            <h1 className="h1_trait_dessus">
              Modifier mes {props.items[props.activeIndex].label}
            </h1>
            <BtnRetour />
          </div>
          <div className="form-demo">
            {/* <div className="flex justify-content-center"> */}
            <div className="card">
              <div className="competences" key={modified}>
                {competences.map((item, indexCompetences) =>
                  modified ? (
                    <div key={item}>
                      <div className="form_bouton_suppr">
                        <h1>Compétence {indexCompetences + 1}</h1>
                        <BtnBlanc
                          btnAction={() => {
                            supprCompetence(indexCompetences, item.id);
                          }}
                        >
                          <FaTrash />
                        </BtnBlanc>
                      </div>
                      <div className="form_columns">
                        <div className="field">
                          <InputText
                            id="competence"
                            placeholder="Esprit d'équipe, autonomie..."
                            key={indexCompetences}
                            value={item.skill}
                            onChange={(e) => majCompetence(e, indexCompetences)}
                          />
                          {item.skill == "" && validated && (
                            <label className="validation">
                              Ce champ doit être renseigné
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : competences.length == 0 ? (
                    "Aucune compétence de renseignée"
                  ) : competences[0].skill == "" ? (
                    "Aucune compétence de renseignée"
                  ) : (
                    <div className="competence" key={indexCompetences}>
                      <h4>{competences[indexCompetences].skill}</h4>
                    </div>
                  )
                )}
              </div>
              {modified && competences.length < 8 && (
                <div className="form_bouton_add">
                  <i
                    className="pi pi-plus-circle"
                    onClick={() => addCompetence()}
                    size="2rem"
                  />
                  <label onClick={() => addCompetence()}>
                    Ajouter une compétence
                  </label>
                </div>
              )}

              <div className="form_boutons">
                {modified ? (
                  <BtnBleuLeft btnTexte="Valider " btnAction={Valider}>
                    <FaCheck />
                  </BtnBleuLeft>
                ) : (
                  <BtnBlancLeft
                    btnTexte="Modifier "
                    btnAction={() => setModified(true)}
                  >
                    <FaPen />
                  </BtnBlancLeft>
                )}
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

Competences.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  handleUpdateAuth: PropTypes.func,
  handleUpdateCompletionLevel: PropTypes.func,
  handleUpdateSkills: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateAuth: (value) => {
    dispatch(updateAuth(value));
  },
  handleUpdateCompletionLevel: (value) => {
    dispatch(updateCompletionLevel(value));
  },
  handleUpdateSkills: (value) => {
    dispatch(updateSkills(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Competences);
